import React, { useState, useEffect } from "react";
import { getComidas, getTrabajadores } from "../../services/apis";
import {
	Box,
	Grid,
	Paper,
	Stack,
	Typography,
	Chip,
	Button,
} from "@mui/material";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import LockIcon from "@mui/icons-material/Lock";
import AddIcon from "@mui/icons-material/Add";
import { ComidaCard } from "./ComidaCard";
import { CrearComidaDialog } from "./CrearComidaDialog";
import { AlertSuccess } from "../../utils/componentes-utiles/AlertError";

const invitadosValor = (invitados, clave) => {
	return invitados?.[clave] || invitados?.[clave.replace("nino", "niño")] || invitados?.[clave.replace("nino", "niÃ±o")] || 0;
};

const contarAsistentes = (comida) => {
	return (comida.asistentes || []).reduce((acc, asistente) => {
		const invitados = asistente.invitados || {};
		return acc + (Number(asistente.miembro_asiste ?? 1) === 1 ? 1 : 0) + invitadosValor(invitados, "invitados") + invitadosValor(invitados, "invitados_nino1") + invitadosValor(invitados, "invitados_nino2");
	}, 0);
};

const formatoFecha = (fecha) => {
	if (!fecha) return "Sin fecha";
	return new Date(fecha).toLocaleDateString("ca-ES", {
		weekday: "long",
		day: "2-digit",
		month: "long",
	});
};

export const Comidas = () => {
	const [comidas, setComidas] = useState([]);
	const [opTrabajadores, setOpTrabajadores] = useState([]);
	const [succesCrearComida, setSuccesCrearComida] = useState(null);
	const [crearComidaOpen, setCrearComidaOpen] = useState(false);

	const cargarComidas = async () => {
		try {
			const response = await getComidas();
			if (response.success) {
				setComidas(response.data);
			} else {
				console.error("Error al cargar las comidas:", response.error);
			}
		} catch (error) {
			console.error("Error en la solicitud:", error);
		}
	};

	const cargarTrabajadores = async () => {
		try {
			const response = await getTrabajadores();
			const tmp = [...response.data];
			const newTmp = tmp.map((item) => ({
				label: item.nombre,
				value: item.id
			}));
			setOpTrabajadores(newTmp);
		} catch (error) {
			console.error("Error cargar tareas", error);
		}
	};

	useEffect(() => {
		cargarComidas();
	}, []);

	useEffect(() => {
		cargarTrabajadores();
	}, []);

	useEffect(() => {
		if (succesCrearComida) {
			cargarComidas();
		}
	}, [succesCrearComida]);

	const comidasOrdenadas = [...comidas].sort((a, b) => {
		const fechaA = `${a.fecha || ""} ${a.hora_inicio || ""}`;
		const fechaB = `${b.fecha || ""} ${b.hora_inicio || ""}`;
		return fechaA.localeCompare(fechaB);
	});

	const comidasPorFecha = comidasOrdenadas.reduce((acc, comida) => {
		const fecha = comida.fecha || "sin-fecha";
		if (!acc[fecha]) acc[fecha] = [];
		acc[fecha].push(comida);
		return acc;
	}, {});

	const comidasCerradas = comidas.filter((comida) => comida.cerrado === 1).length;

	const handleComidaCreada = () => {
		setSuccesCrearComida(true);
		cargarComidas();
	};

	return (
		<Box className="meals-shell">
			<Paper elevation={0} className="meals-header">
				<Box className="meals-header-copy">
					<Typography className="meals-eyebrow">
						Comidas y cenas
					</Typography>
					<Typography variant="h4" className="meals-title">
						Organización de comidas
					</Typography>
				</Box>
				<Stack direction="row" className="meals-header-stats">
					<Button
						variant="contained"
						startIcon={<AddIcon />}
						className="meals-add-button"
						onClick={() => setCrearComidaOpen(true)}
					>
						Afegir
					</Button>
					<Chip icon={<RestaurantIcon />} label={`${comidas.length} comidas`} className="meals-stat-chip" />
					<Chip icon={<LockIcon />} label={`${comidasCerradas} cerradas`} className="meals-stat-chip" />
				</Stack>
			</Paper>

			<Stack className="meals-day-list">
				{Object.entries(comidasPorFecha).map(([fecha, comidasDia]) => {
					const totalDia = comidasDia.reduce((acc, comida) => acc + contarAsistentes(comida), 0);

					return (
						<section key={fecha} className="meals-day-section">
							<Box className="meals-day-heading">
								<Box className="meals-day-title-block">
									<EventAvailableIcon fontSize="small" />
									<Typography variant="h6" className="meals-day-title">
										{formatoFecha(fecha)}
									</Typography>
								</Box>
								<Stack direction="row" className="meals-day-meta">
									<span>{comidasDia.length} servicios</span>
									<span>{totalDia} personas</span>
								</Stack>
							</Box>

							<Grid container spacing={2}>
								{comidasDia.map((comida) => (
									<Grid key={comida.id} size={{ xs: 12, md: 6, xl: 4 }}>
										<ComidaCard
											data={comida}
											totalAsistentes={contarAsistentes(comida)}
											opTrabajadores={opTrabajadores}
											setSuccesCrearComida={setSuccesCrearComida}
										/>
									</Grid>
								))}
							</Grid>
						</section>
					);
				})}
			</Stack>

			{succesCrearComida && (
				<AlertSuccess open={succesCrearComida} setOpen={setSuccesCrearComida} titulo={"Èxit"} mensaje={"Canvis realitzats amb èxit"} tipo={"success"} />
			)}
			<CrearComidaDialog
				open={crearComidaOpen}
				onClose={() => setCrearComidaOpen(false)}
				opTrabajadores={opTrabajadores}
				onCreated={handleComidaCreada}
			/>
		</Box>
	);
};
